import { render, staticRenderFns } from "./VaultStorageSettings.vue?vue&type=template&id=eab1df84"
import script from "./VaultStorageSettings.vue?vue&type=script&lang=js"
export * from "./VaultStorageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports